export const graphColor: any = {
    1: {
        bg: "breach-graph-low-risk-bg",
        dotColor: "low-risk-color-bg-dot",
        text: "Low Risk",
        cardBg: "low-risk-color-bg-card",
        textColor: "low-risk-color",
        circleMain: "low-risk-circle-bg",
        triangleBorder: "low-risk-triangle",
        smallCircle: "low-risk-score-circle",
    },
    2: {
        bg: "breach-graph-low-risk-bg",
        dotColor: "low-risk-color-bg-dot",
        cardBg: "low-risk-color-bg-card",
        text: "Low Risk",
        textColor: "low-risk-color",
    },
    3: {
        bg: "breach-graph-low-risk-bg",
        dotColor: "low-risk-color-bg-dot",
        cardBg: "low-risk-color-bg-card",
        text: "Low Risk",
        textColor: "low-risk-color",
    },
    4: {
        bg: "breach-graph-moderate-risk-bg",
        dotColor: "moderate-risk-color-bg-dot",
        text: "Moderate Risk",
        cardBg: "moderate-risk-color-bg-card",
        textColor: "moderate-risk-color",
        circleMain: "moderate-risk-circle-bg",
        triangleBorder: "moderate-risk-triangle",
        smallCircle: "moderate-risk-score-circle",
    },
    5: {
        bg: "breach-graph-moderate-risk-bg",
        dotColor: "moderate-risk-color-bg-dot",
        text: "Moderate Risk",
        cardBg: "moderate-risk-color-bg-card",
        textColor: "moderate-risk-color",
    },
    6: {
        bg: "breach-graph-moderate-risk-bg",
        dotColor: "moderate-risk-color-bg-dot",
        text: "Moderate Risk",
        cardBg: "moderate-risk-color-bg-card",
        textColor: "moderate-risk-color",
    },
    7: {
        bg: "breach-graph-high-risk-bg",
        dotColor: "high-risk-color-bg-dot",
        text: "High Risk",
        cardBg: "high-risk-color-bg-card",
        textColor: "high-risk-color",
        circleMain: "high-risk-circle-bg",
        triangleBorder: "high-risk-triangle",
        smallCircle: "high-risk-score-circle",
    },
    8: {
        bg: "breach-graph-high-risk-bg",
        dotColor: "high-risk-color-bg-dot",
        text: "High Risk",
        cardBg: "high-risk-color-bg-card",
        textColor: "high-risk-color",
    },
    9: {
        bg: "breach-graph-high-risk-bg",
        dotColor: "high-risk-color-bg-dot",
        text: "High Risk",
        cardBg: "high-risk-color-bg-card",
        textColor: "high-risk-color",
    },
    10: {
        bg: "breach-graph-high-risk-bg",
        dotColor: "high-risk-color-bg-dot",
        text: "High Risk",
        cardBg: "high-risk-color-bg-card",
        textColor: "high-risk-color",
    },
};

export const breachScore: any = {
    1: {
        bg: "",
        dotColor: "",
        text: "Least Protected",
        border: "risk-card-border-least",
        cardBg: "",
        textColor: "",
        circleMain: "",
        triangleBorder: "",
        smallCircle: "",
    },
    2: {
        bg: "",
        dotColor: "",
        cardBg: "",
        text: "Least Protected",
        textColor: "",
    },
    3: {
        bg: "",
        dotColor: "",
        cardBg: "",
        text: "Least Protected",
        textColor: "",
    },
    4: {
        bg: "",
        dotColor: "",
        text: "Slightly Protected",
        border: "risk-card-border-slightly",
        cardBg: "",
        textColor: "",
        circleMain: "",
        triangleBorder: "",
        smallCircle: "",
    },
    5: {
        bg: "",
        dotColor: "",
        text: "Slightly Protected",
        cardBg: "",
        textColor: "",
    },
    6: {
        bg: "",
        dotColor: "",
        text: "Slightly Protected",
        cardBg: "",
        textColor: "",
    },
    7: {
        bg: "",
        dotColor: "",
        text: "Most Protected",
        border: "risk-card-border-most",
        cardBg: "",
        textColor: "",
        circleMain: "",
        triangleBorder: "",
        smallCircle: "",
    },
    8: {
        bg: "",
        dotColor: "",
        text: "Most Protected",
        cardBg: "",
        textColor: "",
    },
    9: {
        bg: "",
        dotColor: "",
        text: "Most Protected",
        cardBg: "",
        textColor: "",
    },
    10: {
        bg: "",
        dotColor: "",
        text: "Most Protected",
        cardBg: "",
        textColor: "",
    },
};

export const detailPage: any = {
    breach_exposure: {
        backLink: "/breaches/exposures",
        selectedTab: "2",
    },
    breach_alert: {
        backLink: "/monitoring",
        selectedTab: "1",
    },
    breach_case: {
        backLink: "/monitoring/cases",
        selectedTab: "1",
    },
    breach_search: {
        backLink: "/breaches/search-breaches-results",
        selectedTab: "4",
    },
};

export const riskFactors = [
    "How many breaches have exposed your personal data",
    "The types of personal information you have had exposed in breaches",
    "The types of risk you face from the breaches involving your information",
    "What actions you have taken to secure your identity in your BreachIQ Action Plan",
];

export const r1 = Array.from({ length: 10 }, (_, i) => i + 1);
export const r2 = Array.from({ length: 10 }, (_, i) => i + 11);
export const r3 = Array.from({ length: 10 }, (_, i) => i + 21);
export const r4 = Array.from({ length: 10 }, (_, i) => i + 31);
export const r5 = Array.from({ length: 10 }, (_, i) => i + 41);
export const r6 = Array.from({ length: 10 }, (_, i) => i + 51);
export const r7 = Array.from({ length: 10 }, (_, i) => i + 61);
export const r8 = Array.from({ length: 10 }, (_, i) => i + 71);
export const r9 = Array.from({ length: 10 }, (_, i) => i + 81);
export const r10 = Array.from({ length: 10 }, (_, i) => i + 91);
